module.exports = __webpack_public_path__ + "static/media/portfolio4.9d6cfb0e.png";